import { render, staticRenderFns } from "./WtProgramLogo.vue?vue&type=template&id=2bb75e41&scoped=true&lang=pug&"
import script from "./WtProgramLogo.vue?vue&type=script&lang=js&"
export * from "./WtProgramLogo.vue?vue&type=script&lang=js&"
import style0 from "./WtProgramLogo.vue?vue&type=style&index=0&id=2bb75e41&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb75e41",
  null
  
)

export default component.exports